import React from "react";
import KosherTeudotBody from "./KosherTeudotBody";
import { Route, Routes } from "react-router-dom";
import TeudotView from "./viewDetails/TeudotView";
import CreateTeuda from "./create/CreateTeuda";
import { LINKS, relPath } from "../../../../Routs/config";

function KosherTeudot() {
  return (
    <Routes>
      <Route index element={<KosherTeudotBody />} />
      <Route element={<TeudotView />} path={relPath(LINKS.teudot.teudotMishloah.editGeneral, LINKS.teudot.teudotMishloah.mainURL)} />
      <Route path={relPath(LINKS.teudot.teudotMishloah.create, LINKS.teudot.teudotMishloah.mainURL)} element={<CreateTeuda />} />
    </Routes>
  );
}

export default KosherTeudot;
